module.exports = __webpack_public_path__ + "static/media/female_lying_portrait.a2c9e126.jpg";